import * as React from 'react';
import * as moment from 'moment';

import { IDay } from '@adage/calendar/services/calendar';

import { IWACEvent } from '../classes/event';

import GridEvent from './grid-event';

export interface GridDayProps {
    day: IDay<IWACEvent>;
}

const gridDay: React.SFC<GridDayProps> = (props) => {
    const dateMoment = moment(props.day.date);

    return (
        <div className="grid-day">
            <h3 className="grid-day-date">
                {dateMoment.format("D")}
            </h3>

            <div className="grid-day-events">
                {
                    props.day.events.map(evt => <GridEvent key={evt.id} event={evt} />)
                }
            </div>
        </div>
    );
}

export default gridDay;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/views/grid-day.tsx